/* eslint-disable max-len */
import React from 'react';
import { useEffectOnce } from 'react-use';
import { LFC } from '../../Legacy';
import { Button, Colors } from '../../ui';
import { Copy, Flexer, Title } from '../dashboard/elements/LayoutElements';
import { Popup, PopupProps } from './Popup';

export type BusyWorkCallback<T> = () => Promise<T>;

export const busyPopup = <T extends unknown>(work: BusyWorkCallback<T>) => ({ ui: BusyPopup, args: { work } });

export const BusyPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {
    const work = args.work as BusyWorkCallback<any>;
    const [error, setError] = React.useState<Error | null>(null);

    useEffectOnce(() => {
        work()
            .then(x => action(x))
            .catch(setError);
    });

    return <Popup>
        {!error &&
            <Flexer padding="2">
                <Title size="2xl" color={Colors.text}>
                    Just a moment...
                </Title>
            </Flexer>
        }
        {error &&
            <>
                <Popup.Content>
                    <Title size="2xl" color={Colors.text}>
                        Operation Failed
                    </Title>
                    <Copy>
                        {error.message}
                    </Copy>
                </Popup.Content>
                <Popup.Actions>
                    <Button onAction={dismiss}>Close</Button>
                </Popup.Actions>
            </>
        }
    </Popup >;
};
